<template>
    <rkm-overlay>
        <rkm-layout-body title="Exames agendados/realizados por paciente">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/exame-imagem/exame-agendado-realizado/List'

export default {
    components: {
        List,
    },
}
</script>